<template>
  <!-- 复合题 -->
  <div
    class="compound-question-wrap"
    :class="{
      ['question_' + questionInfo.id]: true,
    }"
  >
    <div class="question-content-wrap">
      <question-type
        :info="{
          question_type: questionInfo.question_type,
          score: questionInfo.score * questionInfo?.child?.length,
        }"
      />
      <!-- 完型填空题干 -->
      <div
        v-if="
          questionInfo.question_type === QUESTION_TYPE_NAME.COMPLETE_BLANK_FILL
        "
        v-html="handleContent(questionInfo.content)"
        class="question-content complete-blank-fill"
      ></div>
      <!-- 阅读理解题干 -->
      <div v-else class="question-content" v-html="questionInfo.content" />
    </div>
    <div class="question-list-wrap">
      <!-- 题号区域 -->
      <ul class="subIndex-list">
        <li
          class="subIndex-item"
          v-for="subQuestionInfo in hadleQuestionChild"
          :key="subQuestionInfo.id + '_index'"
          @click="handleSubIndexClick(subQuestionInfo)"
          :class="handleSubIndexClass(subQuestionInfo)"
        >
          {{ questionIndexObj[subQuestionInfo.id] + 1 }}
        </li>
      </ul>
      <!-- 展示单个小题 -->
      <div class="question-list" v-if="showSingleQuestion">
        <choice-question
          :key="questionInfo?.child?.[activeIndex].id"
          :question-info="questionInfo?.child?.[activeIndex]"
        />
      </div>
      <!-- 阅读理解 -->
      <div
        v-else
        class="question-list sub-questions-scroll-wrap"
        @scroll="handleScroll"
      >
        <choice-question
          :ref="'question_' + subQuestionInfo.id"
          v-for="subQuestionInfo in hadleQuestionChild"
          :key="subQuestionInfo.id"
          :question-info="subQuestionInfo"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { EventBus } from "@saas/components/src/utils/event-bus";
import {
  QUESTION_TYPE_NAME,
  WORK_STATUS,
} from "@saas/components/src/constants/question";
import ChoiceQuestion from "@saas/pages/src/homework/components/ChoiceQuestion.vue";
import QuestionType from "@saas/pages/src/homework/components/QuestionType.vue";
export default {
  props: {
    questionInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data: function () {
    return {
      changing: false,
      activeSubId: "",
      QUESTION_TYPE_NAME,
      activeIndex: 0,
      WORK_STATUS,
    };
  },
  components: {
    QuestionType,
    ChoiceQuestion,
  },
  mounted() {
    //监听答题卡点击事件
    EventBus.$off(`answer-sheet-click-${this.questionInfo.id}`);
    EventBus.$on(
      `answer-sheet-click-${this.questionInfo.id}`,
      ({ question_id, sub_index }) => {
        this.handleSubIndexClick({
          id: question_id,
          subIndex: sub_index,
        });
      }
    );
    // 默认选中第一个
    this.activeSubId = this.hadleQuestionChild?.[0]?.id;
    // 完型填空题干按钮-初始化
    if (
      this.questionInfo?.question_type ===
      QUESTION_TYPE_NAME.COMPLETE_BLANK_FILL
    ) {
      this.initQuestionButtonClick();
    }
  },
  methods: {
    initQuestionButtonClick() {
      this.$nextTick(() => {
        setTimeout(() => {
          // 事件委托
          let questionBtnsParent = document.querySelector(
            `.question_${this.questionInfo.id} .question-content.complete-blank-fill`
          );
          questionBtnsParent.addEventListener("click", (e) => {
            let item = e.target;
            if (e.target.classList.contains("question-button")) {
              console.log("点击事件触发");
              if (this.showErrorAnalysis) {
                // 错题解析-非正确题按钮点击事件添加
                if (!item.classList.contains("is-right")) {
                  this.handleQuestionBtnClick(item);
                }
              } else {
                this.handleQuestionBtnClick(item);
              }
            }
            e.stopPropagation();
          });
        }, 250);
      });
    },
    // 完型填空题干按钮-点击事件
    handleQuestionBtnClick(item) {
      const id = Number(item.getAttribute("data-id"));
      const subIndex = Number(item.getAttribute("sub-index"));
      this.handleSubIndexClick({
        id,
        subIndex,
      });
    },
    // 阅读理解-监听滚动-高亮题号
    handleScroll(event) {
      if (this.changing) return;
      const { scrollTop } = event.target;
      // 1. 将对象的属性名提取到一个数组中
      const propertyKeys = [];
      for (const key in this.$refs) {
        propertyKeys.push(key);
      }
      // 2. 对数组进行倒序遍历
      for (let i = propertyKeys.length - 1; i >= 0; i--) {
        const key = propertyKeys[i];
        const element = this.$refs[key]?.[0]?.$el;
        const judge = scrollTop >= element?.offsetTop;
        if (judge) {
          this.activeSubId = Number(key.replace("question_", ""));
          break;
        }
      }
    },
    handleSubIndexClick(subQuestionInfo) {
      let { id, subIndex } = subQuestionInfo;
      if (this.showSingleQuestion) {
        // 完型填空
        this.activeSubId = id;
        this.activeIndex = subIndex;
      } else {
        // 阅读理解
        this.changing = true;
        this.activeSubId = id;
        let ref = this.$refs["question_" + id]?.[0]?.$el;
        let el = document.querySelector(
          `.question_${this.questionInfo.id} .sub-questions-scroll-wrap`
        );
        if (ref && el) {
          el.scrollTo({
            top: ref?.offsetTop || 0,
            behavior: "smooth",
          });
        }
        setTimeout(() => {
          this.changing = false;
        }, 2000);
      }
    },
  },
  computed: {
    ...mapState("defaultHomework", [
      "workInfo",
      "questionList",
      "isCorrected",
      "showErrorAnalysis",
    ]),
    ...mapGetters("defaultHomework", ["questionIndexObj"]),
    handleSubIndexClass() {
      return (subQuestionInfo) => {
        const { right, userAnswer } = subQuestionInfo;
        return {
          "is-active": this.activeSubId === subQuestionInfo.id,
          "is-answer": userAnswer,
          "is-right": this.isCorrected && userAnswer && right === 1,
          "is-wrong": this.isCorrected && userAnswer && right === 2,
        };
      };
    },
    showSingleQuestion() {
      return (
        this.questionInfo.question_type ===
          QUESTION_TYPE_NAME.COMPLETE_BLANK_FILL || this.isCorrected
      );
    },
    hadleQuestionChild() {
      if (this.showErrorAnalysis) {
        return this.questionInfo?.errorChild || [];
      } else {
        return this.questionInfo.child || [];
      }
    },
    // 会实时渲染完型题干中按钮状态
    handleContent() {
      return (htmlString) => {
        try {
          // 去除零宽度空格
          const cleanHtmlString = htmlString.replace(/\u200B/g, "");
          let index = 0; //问题序号
          const newHtmlString = cleanHtmlString.replace(
            // eslint-disable-next-line no-irregular-whitespace
            /<question-button([^>]*)>﻿<span[^>]*>问 (\d+)<\/span>﻿<\/question-button>/g,
            (match, attributes, number) => {
              // 移除样式属性和class
              let newAttributes = attributes.replace(/style="[^"]*"/, "");
              newAttributes = newAttributes.replace(/class="[^"]*"/, "");
              // 构建新的 question-button 标签
              let { id, right, userAnswer } = this.questionInfo?.child?.[index]; //问题详情
              number = this.questionIndexObj?.[id] + 1; // 整个作业中的序号
              let otherClass = []; // 其他类名
              if (userAnswer) {
                otherClass.push("is-answer");
              }
              if (this.activeSubId === id) {
                otherClass.push("is-active");
              }
              if (this.isCorrected && userAnswer) {
                if (right === 1) {
                  otherClass.push("is-right");
                } else if (right === 2) {
                  otherClass.push("is-wrong");
                }
              }
              otherClass = otherClass.join(" ");
              // eslint-disable-next-line no-irregular-whitespace
              const newButton = `<question-button${newAttributes} class='question-button question-btn-${
                id || ""
              } ${
                otherClass || ""
              }' data-id=${id} sub-index=${index}>${number}</question-button>`;
              index++; //问题序号
              return newButton;
            }
          );
          return newHtmlString;
        } catch (error) {
          console.log(error, "error===");
        }
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.compound-question-wrap {
  display: flex;
  .question-content-wrap,
  .question-list-wrap {
    display: flex;
    flex-direction: column;

    background: #ffffff;
    border-radius: 12px;
    max-height: 600px;
    overflow-y: auto;
  }
  .question-content-wrap {
    flex: 1;
    padding: 20px 0 20px 20px;
    margin-right: 16px;
    ::v-deep .question-content {
      line-break: anywhere;
      flex: 1;
      font-weight: 500;
      font-size: 16px;
      color: #1d2129;
      line-height: 28px;
      overflow-y: auto;
      padding-right: 11px;
      .question-button {
        display: inline-block;
        width: 28px;
        height: 28px;
        background: #f2f3f5;
        border: 2px solid #f2f3f5;
        border-radius: 50%;
        text-align: center;
        margin: 0 8px;
        position: relative;
        cursor: pointer;
        font-weight: 500;
        font-size: 16px;
        color: #4e5969;
        line-height: 24px;
        &::after {
          left: -2px;
          bottom: -2px;
          position: absolute;
          content: "";
          display: flex;
          width: 28px;
          height: 1px;
          background: #86909c;
          border-radius: 1px;
        }
        &.is-active {
          border-color: #86909c;
          color: #4e5969;
          background-color: #f2f3f5;
        }
        &.is-answer {
          background: $homework-default-bg;
          color: $homework-default-color;
          border-color: $homework-default-bg;
          &.is-active {
            border-color: #386bff;
          }
        }
        &.is-right {
          background: $homework-right-bg;
          color: $homework-right-color;
          border-color: $homework-right-bg;
          &.is-active {
            border-color: $homework-right-color;
          }
        }
        &.is-wrong {
          background: $homework-wrong-bg;
          color: $homework-wrong-color;
          border-color: $homework-wrong-bg;
          &.is-active {
            border-color: $homework-wrong-color;
          }
        }
      }
    }
  }
  .question-list-wrap {
    width: 584px;
    padding: 8px 0 8px 2px;
    .subIndex-list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      border-bottom: 1px #f2f3f5 solid;
      padding-bottom: 8px;
    }
    .subIndex-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
      background: #f2f3f5;
      font-weight: 600;
      font-size: 14px;
      color: #4e5969;
      line-height: 20px;
      border-radius: 50%;
      border: 2px solid #f2f3f5;
      margin: 8px 10px;
      cursor: pointer;
      // &:nth-child(12n) {
      //   margin-right: 0;
      // }
      &.is-active {
        border-color: #86909c;
        color: #4e5969;
        background-color: #f2f3f5;
      }
      &.is-answer {
        background: $homework-default-bg;
        color: $homework-default-color;
        border-color: $homework-default-bg;
        &.is-active {
          border-color: #386bff;
        }
      }
      &.is-right {
        background: $homework-right-bg;
        color: $homework-right-color;
        border-color: $homework-right-bg;
        &.is-active {
          border-color: $homework-right-color;
        }
      }
      &.is-wrong {
        background: $homework-wrong-bg;
        color: $homework-wrong-color;
        border-color: $homework-wrong-bg;
        &.is-active {
          border-color: $homework-wrong-color;
        }
      }
    }
    .question-list {
      position: relative;
      flex: 1;
      overflow-y: auto;
      padding-right: 7px;
    }
    .choice-question-wrap {
      padding: 12px 0 18px 12px;
    }
  }
  .question-content,
  ::v-deep .question-list {
    margin-right: 5px;
    &:hover::-webkit-scrollbar-thumb {
      background: #f7f8fa;
    }
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: transparent;
      // background: #f7f8fa;
      border-radius: 2px;
    }
    .mark-btn {
      right: 0;
    }
  }
}

// 适配
@media (max-width: 1200px) {
  .compound-question-wrap {
    .question-content-wrap,
    .question-list-wrap {
      flex: 1;
      width: auto;
      min-width: 350px;
    }
  }
}
@media (max-width: 715px) {
  .compound-question-wrap {
    display: flex;
    flex-direction: column;
    .question-content-wrap,
    .question-list-wrap {
      width: 100%;
    }
    .question-content-wrap {
      border-radius: 12px 12px 0px 0px;
      margin-right: 0;
    }
    .question-list-wrap {
      border-radius: 0px 0px 12px 12px;
      border-top: 1px #f2f3f5 solid;
    }
  }
}
</style>
